// @ts-nocheck
import React, { useEffect, useState } from 'react'
import { listUsers } from '../graphql/queries';
import { generateClient } from 'aws-amplify/api';
import { createOrganization, createUserOrganizations } from '../graphql/mutations';
import { createUserOrganizationsCustom } from '../graphql/customMutations'
import ProfilePictureRounded from './ProfilePictureRounded';
import { uploadData } from '@aws-amplify/storage';

import Select from "./ReusableComponents/Select";
const defaultFormState = {
  name:"",
  description:"",
  owner:""
}

const client = generateClient();
const AdminAddOrganization = ({ onCompleted }) => {

    const [file, setFile] = useState(null);
    const [selectedImage, setSelectedImage] = useState(null);
    const [userList, setUserList] = useState([])
    const [formState, setFormState] = useState(defaultFormState)
    const [selectedItems, setSelectedItems] = useState([]);
    const [memberSearch, setMemberSearch] = useState("");
    const [formComplete, setFormComplete] = useState(false)
    const [organizationOwner, setOrganizationOwner] = useState(null)
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [submitError, setSubmitError] = useState(null)

    // set user state
    const getAllUsers = async () => {
        const client = generateClient();
        const { data } = await client.graphql({
            query: listUsers,
          });
          setUserList(data.listUsers.items)
    }
    // submit if it works, green light!

    useEffect(()=>{
        getAllUsers()
    },[])

    const handleChange = (e) => {
      if(e.target.name === "owner") {
        const selectedOwner = userList.find((userProfiles) => userProfiles.id === e.target.value)
        console.log("selectedOwner", selectedOwner)
        setOrganizationOwner(selectedOwner)
      }
        setFormState((prevData) => ({
            ...prevData,
            [e.target.name]: e.target.value, // Update the specific field
          }));
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (isSubmitting) return;
        setSubmitError(null);
        // Validate up front — the old silent failure here made the button look dead
        if (!formState.name?.trim()) {
            setSubmitError("Organization name is required.");
            return;
        }
        if (!formState.owner) {
            setSubmitError("Select an owner before creating the organization.");
            return;
        }
        setIsSubmitting(true);
        try{
            const organizationId = formState.name.toLowerCase().replace(/\s/g,'')
            let fileKey = await handleUploadFile(file, organizationId)
            let submitForm = {...formState}
            submitForm["id"] = organizationId
            submitForm["profilePictureUrl"] = fileKey
            
            console.log("SUBMITFORM", submitForm)
            const { data } = await client.graphql({
                query: createOrganization,
                variables: { input:submitForm },
            });

            const organizationSubmitted = data.createOrganization
            console.log("organizationSubmitted", organizationSubmitted)
            for (const userId of selectedItems) {
                
                const { data } = await client.graphql({
                    query: createUserOrganizationsCustom,
                    variables: { input:{
                      organizationId: organizationSubmitted.id,
                        userID: userId
                                } 
                            },
                    });
                console.log("Create user Organization", data)
            }
            setFormState(defaultFormState)
            setSelectedItems([])
            setSelectedImage(null)
            setFile(null)
            setFormComplete(true)
            // In the modal, success closes the frame; the inline success message only shows standalone
            if (onCompleted) onCompleted()

        } catch (e) {
            console.log("errror", e)
            setSubmitError("Could not create the organization — see the console for details.");
        } finally {
            setIsSubmitting(false);
        }
    }

    const isSelected = (id) => selectedItems.includes(id);

    // Selection lives in state, so users picked before a narrower search stay selected while hidden
    const memberSearchTerm = memberSearch.trim().toLowerCase();
    const filteredUserList = memberSearchTerm
      ? userList.filter(
          (user) =>
            (user.name || "").toLowerCase().includes(memberSearchTerm) ||
            (user.email || "").toLowerCase().includes(memberSearchTerm)
        )
      : userList;

    const handleSelect = (id) => {
        setSelectedItems((prevSelected) => {
          if (prevSelected.includes(id)) {
            // If item is already selected, remove it
            return prevSelected.filter((item) => item !== id);
          } else {
            // If item is not selected, add it
            return [...prevSelected, id];
          }
        });
      };

    const handleFileChange = (event) => {
      const fileUploaded = event.target.files[0];
          if (fileUploaded) {
          // Use FileReader to generate a preview URL
          const reader = new FileReader();
          reader.onloadend = () => {
              setSelectedImage(reader.result); // Set the preview URL
          };
          reader.readAsDataURL(fileUploaded); // Read the file as a Data URL
          setFile(fileUploaded)
          } else {
          setSelectedImage(null); // Clear preview if no file is selected
          }
        };

        const handleUploadFile = async (uploadFile, organizationId) => {
          // Guard first — dereferencing a not-yet-selected owner here used to throw and kill the whole submit
          if (!uploadFile || !organizationId || !organizationOwner?.cognitoIdentityId) return null;
          try {
              const result = await uploadData({
                path: ({identityId}) => {
                  // let ownerCogId = organizationOwner.cognitoIdentityId
                  const path = `organizationprotected/${organizationId}/profilePic/${uploadFile.name}`  
                  console.log("Path", path)
                  return path
                },
                data: uploadFile,
                options: {
                  // onProgress // Optional progress callback.
                }
              }).result;
            return result.path; // Return the file's S3 location key
          } catch (error) {
            console.error("Error uploading file:", error);
            return null;
          }
      }


  return (
    <div>
      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Left Column - Form Fields */}
          <div className="space-y-4">
            <div>
              <label className="block text-gray-700 text-sm font-medium mb-2">
                Organization Name
              </label>
              <input 
                className="shadow-sm border border-gray-300 rounded-md py-2 px-3 w-full focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                value={formState.name} 
                onChange={handleChange} 
                name="name"
              />
            </div>
            
            <div>
              <label className="block text-gray-700 text-sm font-medium mb-2">
                Description
              </label>
              <textarea 
                className="shadow-sm border border-gray-300 rounded-md py-2 px-3 w-full focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 min-h-[100px]"
                value={formState.description} 
                name="description" 
                onChange={handleChange}
              />
            </div>
            
            <div>
              <label className="block text-gray-700 text-sm font-medium mb-2">
                Owner
              </label>
              <Select 
                value={formState.owner} 
                onChange={handleChange} 
                name="owner"
                containerClassName="w-full"
              >
                <option value="">Select an owner</option>
                {userList.map((user) => (
                  <option value={user.id} key={user.id}>
                    {user.name} - {user.email}
                  </option>
                ))}
              </Select>
            </div>
          </div>
          
          {/* Right Column - Profile Picture */}
          <div className="bg-gray-50 rounded-lg p-6">
            <h3 className="text-gray-700 text-sm font-medium mb-4">Organization Profile Picture</h3>
            <div className="flex flex-col items-center">
              <div className="mb-4">
                {selectedImage ? (
                  <img
                    src={selectedImage}
                    alt="Preview"
                    className="w-32 h-32 rounded-full border-2 border-gray-200 object-cover"
                  />
                ) : (
                  <ProfilePictureRounded diameter={128} />
                )}
              </div>
              
              <div className="w-full">
                <input
                  id="profile-photo"
                  type="file"
                  accept="image/png, image/jpeg"
                  onChange={handleFileChange}
                  className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 hover:cursor file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
                />
              </div>
            </div>
          </div>
        </div>
        
        {/* Members Section */}
        <div className="mt-6">
          <h3 className="text-gray-700 text-sm font-medium mb-4">
            Organization Members
            {selectedItems.length > 0 && ` (${selectedItems.length} selected)`}
          </h3>
          <input
            type="text"
            value={memberSearch}
            onChange={(e) => setMemberSearch(e.target.value)}
            placeholder="Search by name or email"
            aria-label="Search members by name or email"
            className="shadow-sm border border-gray-300 rounded-md py-2 px-3 w-full mb-3 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
          />
          <div className="bg-gray-50 rounded-lg p-4 max-h-[300px] overflow-y-auto">
            {filteredUserList.length === 0 && (
              <div className="p-2 text-sm text-gray-500">No members match "{memberSearch}"</div>
            )}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
              {filteredUserList.map((option) => (
                <div key={option.id} className="flex items-center p-2 hover:bg-gray-100 rounded-md">
                  <input
                    type="checkbox"
                    id={`user-${option.id}`}
                    checked={isSelected(option.id)}
                    onChange={() => handleSelect(option.id)}
                    className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                  />
                  <label htmlFor={`user-${option.id}`} className="ml-3 block text-sm text-gray-700 cursor-pointer">
                    <div className="font-medium">{option.name}</div>
                    <div className="text-xs text-gray-500">{option.email}</div>
                  </label>
                </div>
              ))}
            </div>
          </div>
        </div>
        
        {/* Submit Button */}
        <div className="flex items-center justify-end gap-3 pt-4">
          {submitError && (
            <p className="text-sm text-red-600" role="alert">{submitError}</p>
          )}
          <button
            type="submit"
            disabled={isSubmitting}
            className="px-4 py-2 bg-blue-600 text-white font-medium rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none"
          >
            {isSubmitting ? "Creating…" : "Create Organization"}
          </button>
        </div>
        
        {formComplete && (
          <div className="mt-4 p-3 bg-green-50 text-green-800 rounded-md">
            <div className="flex items-center">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              Organization created successfully!
            </div>
          </div>
        )}
      </form>
    </div>
  )
}

export default AdminAddOrganization